import React from 'react';
import { ReactComponent as MailIcon } from '@blink/assets/src/icons/mail.svg';
import { ReactComponent as ClockIcon } from '@blink/assets/src/icons/clock.svg';
import { formatDistanceToNow, parseISO } from 'date-fns';

interface LastActiveProps {
    lastActive?: string;
    lastSeen?: string;
}

export const LastActive: React.FC<LastActiveProps> = ({ lastActive, lastSeen }) => {
    const renderTimeInfo = (dateString: string, isLastActive: boolean) => {
        if (!dateString || dateString === 'N/A') {
            return (
                <div className='flex items-center gap-3 text-md text-primary'>
                    <MailIcon className='w-5 h-5' />
                    <span>N/A</span>
                </div>
            );
        }

        try {
            const date = parseISO(dateString);
            const formattedTime = formatDistanceToNow(date, { addSuffix: true });

            return (
                <div className='flex items-center gap-3 text-md text-primary'>
                    {isLastActive ? (
                        <ClockIcon className='w-5 h-5' />
                    ) : (
                        <MailIcon className='w-5 h-5' />
                    )}
                    <span>{isLastActive ? formattedTime : `Sent ${formattedTime}`}</span>
                </div>
            );
        } catch (error) {
            console.error('Error parsing date:', dateString, error);
            return null;
        }
    };

    return lastActive ? renderTimeInfo(lastActive, true) : renderTimeInfo(lastSeen || 'N/A', false);
};
